import { setAccessToken as setGraphqlToken } from '../../../graphql/client';
import { GlobalAuthInfo } from '../../api/custom-instance';

/**
 * TokenManager
 *
 * V2 (Axios)와 기존 GraphQL (Apollo) 간 토큰을 통합 관리하는 싱글톤 클래스
 *
 * 관리하는 토큰 저장소:
 * 1. GlobalAuthInfo.AccessToken (V2 Axios)
 * 2. graphql/client.ts의 accessToken (Apollo)
 * 3. Recoil AuthState.jwt는 use-auth.ts에서 직접 관리
 */
class TokenManager {
  private static instance: TokenManager;

  // eslint-disable-next-line no-useless-constructor
  private constructor() {}

  static getInstance(): TokenManager {
    if (!TokenManager.instance) {
      TokenManager.instance = new TokenManager();
    }
    return TokenManager.instance;
  }

  /**
   * 토큰 설정
   * V2 Axios와 GraphQL Apollo Client 모두에 토큰 적용
   */
  // eslint-disable-next-line class-methods-use-this
  setToken(token: string | null) {
    const tokenValue = token || '';

    // 1. V2 Axios 인스턴스
    GlobalAuthInfo.AccessToken = tokenValue;

    // 2. GraphQL Apollo Client
    setGraphqlToken(token);

    // Note: Recoil AuthState는 use-auth.ts에서 직접 관리
    // 여기서 Recoil을 업데이트하면 순환 참조 발생 가능
  }

  /**
   * 토큰 조회
   */
  // eslint-disable-next-line class-methods-use-this
  getToken(): string | null {
    return GlobalAuthInfo.AccessToken || null;
  }

  /**
   * 토큰 삭제
   */
  clearToken() {
    this.setToken(null);
  }
}

export const tokenManager = TokenManager.getInstance();
